import React, { useEffect, useState } from "react";
import { Box, Typography, List, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@emotion/react";
import { getProjectsDataApi } from "../api/project";
import { BrowserView, isBrowser } from "react-device-detect";

const wrapDiv = {
  px: isBrowser ? 4 : 1,
  background: "linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), url('assets/background/projectbg.png')",
  backgroundSize: "auto",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right bottom",
};

const wrapDivMobile = {
  p: 1,
};

const listStyle = {
  width: "100%",
  display: "flex",
  cursor: "pointer",
  borderRadius: "10px",
  px: 4,
  py: 2,
  mb: 1.5,
  color: "#fff",
};

const goingColor = {
  background: "#00B176",
  "&:hover": {
    background: "linear-gradient(90deg, #00B176 50%,#EFDF00 100%)",
  },
};

const finishedColor = {
  background: "#A2ACA8",
  "&:hover": {
    background: "linear-gradient(90deg, #A2ACA8 50%,#454D4AFF 100%)",
  },
};

const notStartColor = {
  background: "#fff",
  border: "2px solid #A2ACA8",
  color: "#000",
  py: "14px",
  "&:hover": {
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
  },
};

const ProjectItem = ({ project, handleClick }) => (
  <Box
    onClick={() => handleClick(project.id)}
    sx={{
      ...listStyle,
      alignItems: "center",
      ...(project.status === "On-Going" ? goingColor : project.status === "Finished" ? finishedColor : notStartColor),
    }}
  >
    <BrowserView>
      {project.status === "Not-Started" ? (
        <img src="assets/icons/greyarrowdouble.svg" alt="arrow double" style={{ height: "27px", verticalAlign: "bottom" }} />
      ) : (
        <img src="assets/icons/arrowdouble.svg" alt="arrow double" style={{ height: "27px", verticalAlign: "bottom" }} />
      )}
    </BrowserView>
    <Box
      component="span"
      sx={{
        fontSize: isBrowser ? "20px" : "16px",
        fontWeight: 600,
        ml: isBrowser ? 1.5 : 0,
        flex: isBrowser ? 3 : 2,
      }}
    >
      {project.projectName}
    </Box>
    <Box component="span" flex={1} sx={{ fontSize: isBrowser ? "18px" : "16px" }}>
      {project.status}
    </Box>
  </Box>
);

const PortfolioPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const headListStyle = {
    width: "100%",
    display: "flex",
    borderRadius: "10px",
    background: theme.palette.primary.main,
    px: 4,
    py: 2,
    color: "#fff",
  };

  const getProjects = async () => {
    setIsLoading(true);
    const response = await getProjectsDataApi();
    const projects = response.data;

    if (projects.length === 1) {
      handleModuleClick(projects[0].id);
    }
    setProjects(projects);
    setIsLoading(false);
  };

  const handleModuleClick = (id) => {
    if (isBrowser) {
      navigate(`/modules/Project/${id}`);
    } else {
      navigate(`/modules/3DModel/${id}`);
    }
  };

  useEffect(() => {
    getProjects();
  }, []);

  return (
    <Box width="100%" height="100%" sx={isBrowser ? wrapDiv : wrapDivMobile}>
      <BrowserView>
        <Typography variant="h4" sx={{ fontWeight: 600, mb: 2 }}>
          Project Portfolio
        </Typography>
      </BrowserView>
      <Box sx={headListStyle}>
        <Box
          component="span"
          sx={{
            fontSize: isBrowser ? "18px" : "16px",
            fontWeight: 600,
            ml: isBrowser ? 5 : 0,
            flex: isBrowser ? 3 : 2,
          }}
        >
          Project Name
        </Box>
        <Box component="span" flex={1} sx={{ fontSize: "16px" }}>
          Status
        </Box>
      </Box>
      <List
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          pt: 1.5,
        }}
      >
        {projects.map((project) => (
          <ProjectItem key={project.id} project={project} handleClick={handleModuleClick} />
        ))}
      </List>
      {projects.length === 0 && (
        <Box
          sx={{
            width: "100%",
            px: 0,
            py: 2,
            backgroundColor: "transparent",
            borderRadius: "10px",
            m: 0,
            textAlign: "center",
          }}
        >
          {isLoading ? <CircularProgress /> : <Typography variant="h5">Your account is not assigned to any project at the moment</Typography>}
        </Box>
      )}
    </Box>
  );
};

export default PortfolioPage;
